import { render, staticRenderFns } from "./NotDefined.vue?vue&type=template&id=72b65621&scoped=true&"
import script from "./NotDefined.vue?vue&type=script&lang=js&"
export * from "./NotDefined.vue?vue&type=script&lang=js&"
import style0 from "./NotDefined.vue?vue&type=style&index=0&id=72b65621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b65621",
  null
  
)

export default component.exports